
import Server from "src/server";
import Util from "src/util/util";

export default
  {
    namespaced: true,
    state:
    {
      isLoading: false,
      user: null,
      users: [],
      groups: [],
    },

    mutations:
    {

    },

    actions:
    {
      reset(context) {
        context.state.user = null;
      },

      async login(context, { username, password }) {
        try {
          var result = await Server.post("authUser", { username: username, password: password }).promise;
          if (!result.data.success)
            throw (result.data.error);

          localStorage.setItem("token", result.data.token);
          context.dispatch("init", {}, { root: true });
          return result;
        }
        catch (e) {
          console.log("Failed 'authUser' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }
      },

      logout(context) {
        localStorage.setItem("token", "");
        context.dispatch("reset", {}, { root: true });
      },

      async setUser(context, { token }) {
        try {
          context.state.isLoading = true;
          var result = await Server.post("getUserForToken", { token: token }).promise;
          context.state.isLoading = false;
          if (!result.data.success)
            throw (result.data.error);

          context.state.user = result.data.user;

          // init parms object if it doesn't exist
          if (!context.state.user.parms) {
            context.state.user.parms = {};
          }
          return result;
        }
        catch (e) {
          console.log("Failed 'getUserForToken' server call. " + e.toString());
          context.dispatch("logout", {}, { root: true });
          context.state.isLoading = false;
          return { data: { success: false, error: e } };
        }
      },

      async setUsers(context) {
        try {
          var result = await Server.post("getUsers").promise;
          if (!result.data.success)
            throw (result.data.error);

          context.state.users = result.data.users;
          return result;
        }
        catch (e) {
          console.log("Failed 'getUsers' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }
      },

      async setGroups(context) {
        try {
          var result = await Server.post("getGroups").promise;
          if (!result.data.success)
            throw (result.data.error);

          context.state.groups = result.data.groups;
          return result;
        }
        catch (e) {
          console.log("Failed 'getGroups' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }
      },

      async changePassword(context, { oldPassword, newPassword }) {
        try {
          var result = await Server.post("changePassword", { oldPassword: oldPassword, newPassword: newPassword }).promise;
          if (!result.data.success)
            throw (result.data.error);

          return result;
        }
        catch (e) {
          console.log("Failed 'changePassword' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }

      },

      async insertUser(context, { user }) {
        try {
          var result = await Server.post("insertUser", { user }).promise;
          if (!result.data.success)
            throw (result.data.error);

          context.state.users.push(result.data.user);
          return result;
        }
        catch (e) {
          console.log("Failed 'insertUser' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }
      },

      async updateUser(context, { user }) {
        try {
          var result = await Server.post("updateUser", { user }).promise;
          if (!result.data.success)
            throw (result.data.error);

          context.state.users = Util.replaceInArray(context.state.users, "_id", result.data.user);
          return result;
        }
        catch (e) {
          console.log("Failed 'updateUser' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }
      },

      async updateUserParms(context, { user }) {
        try {
          Server.post("updateUserParms", { user }).promise.then((result) => {
            if (!result || !result.data || !result.data.success) {
              throw result.data.error;
            }
            context.state.users = Util.replaceInArray(context.state.users, "_id", result.data.user);
            return result;
          });
        }
        catch (e) {
          console.log("Failed to update user parameters." + e.toString());
          return { data: { success: false, error: e } };
        }
      },

      async deleteUser(context, { user }) {
        try {
          var result = await Server.post("deleteUser", { user }).promise;
          if (!result.data.success)
            throw (result.data.error);

          context.state.users = Util.removeFromArrayByKey(context.state.users, "_id", user._id);
          return result;
        }
        catch (e) {
          console.log("Failed 'deleteUser' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }
      },

      async insertGroup(context, { group }) {
        try {
          var result = await Server.post("insertGroup", { group }).promise;
          if (!result.data.success)
            throw (result.data.error);

          context.state.groups.push(result.data.group);
          return result;
        }
        catch (e) {
          console.log("Failed 'insertGroup' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }
      },

      async updateGroup(context, { group }) {
        try {
          var result = await Server.post("updateGroup", { group }).promise;
          if (!result.data.success)
            throw (result.data.error);

          context.state.groups = Util.replaceInArray(context.state.groups, "_id", result.data.group);
          return result;
        }
        catch (e) {
          console.log("Failed 'updateGroup' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }
      },

      async deleteGroup(context, { group }) {
        try {
          var result = await Server.post("deleteGroup", { group }).promise;
          if (!result.data.success)
            throw (result.data.error);

          context.state.groups = Util.removeFromArrayByKey(context.state.groups, "_id", group._id);
          return result;
        }
        catch (e) {
          console.log("Failed 'deleteGroup' server call. " + e.toString());
          return { data: { success: false, error: e } };
        }
      },

    },

    getters:
    {

    }
  };



// WEBPACK FOOTER //
// ./src/store/user.js